import CryptoJS from 'crypto-js'
import crypto from 'crypto'

// aes 解密
export const aesDecode = (secret, content) => {
  const key = CryptoJS.enc.Utf8.parse(secret)
  const iv = CryptoJS.enc.Utf8.parse(secret.slice(0, 16))
  // Decode hex
  // let encryptedHexStr = CryptoJS.enc.Hex.parse(content)
  // let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
  let srcs = content
  let decrypt = CryptoJS.AES.decrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
  return decryptedStr.toString()
}

// aes 加密
export const aesEncode = (secret, content) => {
  const key = CryptoJS.enc.Utf8.parse(secret)
  const iv = CryptoJS.enc.Utf8.parse(secret.slice(0, 16))
  let srcs = CryptoJS.enc.Utf8.parse(content)
  let encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
  // Return hex string
  // return encrypted.ciphertext.toString().toUpperCase()
  return '' + encrypted
}

export const md5 = (str) => {
  const md5Encode = crypto.createHash('md5')
  md5Encode.update(str)
  return md5Encode.digest('hex')
}



// WEBPACK FOOTER //
// ./src/utils/crypto.js